import { HttpPostRequestAbortable } from "./HttpRequest.js";

export async function all(startDate, endDate, payload, signal) {
  let url = "/stats?start_at=" + startDate.format('YYYYMMDD') + '&end_at=' + endDate.format('YYYYMMDD');
  return await HttpPostRequestAbortable(url, payload, signal).then((response) => {
    return response.json();
  });
}
